export type DiagEvent = { t: number; kind: "console" | "network"; message: string; level?: string };

export interface Diagnostics {
  record(kind: DiagEvent["kind"], message: string, level?: string): void;
  snapshot(): DiagEvent[];
}

// Единый inspectable слой (testability §E): один буфер, timeline-stamped от общего t0.
// Один потребитель — тест-оракул (/bt), второй — session-repro capture. Не плодить параллельные коллекторы.
export function createDiagnostics(now: () => number = () => Date.now()): Diagnostics {
  const t0 = now();
  const events: DiagEvent[] = [];
  return {
    record(kind, message, level) { events.push({ t: now() - t0, kind, message, level }); },
    snapshot() { return events.map((e) => ({ ...e })); },
  };
}
